
import coupon from './_coupon'


/** 流量看板 */
export default {
  noHeader: true,

  body: {
    type: 'page-tabs',
    default: 'coupon',
    items: [
      { label: '优惠券', value: 'coupon', body: coupon.body },
    ]
  }
}
